import React from "react";
import Select from "react-select";

// Options are derived from the Types API (passed in by the parent) so the
// selectable list, labels and ordering all come from the backend rather than
// a hardcoded array.
const TypeSelector = ({ type, setType, types = [] }) => {
  const options = types.map((t) => ({ value: t.key, label: t.title }));
  return (
    <div>
      <label>Select Type</label>
      <Select
        isMulti
        options={options}
        value={options.filter(option => type.includes(option.value))}
        onChange={(selectedOptions) => setType(selectedOptions.map(option => option.value))}
        placeholder="Select Types..."
      />
    </div>
  );
};

export default TypeSelector;
